import Layout from "@/components/Layout";
import { Link } from "react-router-dom";

const STEPS = [
  { n: "01", t: "Subscribe and secure a Test ID", d: "Choose a plan and complete payment. A unique single-use Test ID is generated and emailed instantly." },
  { n: "02", t: "Enter your Test ID", d: "On the Take Test page, enter your Test ID and the email it was issued to." },
  { n: "03", t: "Verify your email via OTP", d: "Receive a 6-digit OTP. Verify ownership of the email. The Test ID is then locked to this email." },
  { n: "04", t: "Complete your profile and consent", d: "Enter your name, optional institution code, program/batch, and confirm consent." },
  { n: "05", t: "Choose 3 to 9 domains", d: "Select between 3 and 9 specialization domains. The shorter the test, the fewer items you answer." },
  { n: "06", t: "Read instructions and start the test", d: "Review the test instructions, then click 'Start the Test' when ready." },
  { n: "07", t: "Respond to one item at a time", d: "5-point Likert scale. 20-second timer per item. If you don't respond, the system defaults to Neutral and moves on." },
  { n: "08", t: "Submit and receive your report", d: "After the last item, click 'Submit'. A detailed PDF report is generated and emailed to you (and your institution, if applicable)." },
];

export default function HowItWorks() {
  return (
    <Layout>
      <section className="container-msis py-16">
        <div className="overline mb-3">How It Works</div>
        <h1 className="font-display font-bold text-4xl sm:text-5xl tracking-tighter max-w-3xl">A precise, secure flow — from sign-up to insight.</h1>
        <p className="mt-5 text-base text-slate2 max-w-3xl">Every step is designed to protect data integrity and ensure a single-use, single-respondent Test ID experience.</p>
      </section>
      <section className="container-msis pb-24">
        <ol className="grid grid-cols-1 md:grid-cols-2 gap-px bg-border">
          {STEPS.map((s) => (
            <li key={s.n} className="bg-white p-6">
              <div className="font-mono text-xs text-slate2">{s.n}</div>
              <div className="font-display font-bold text-lg mt-2">{s.t}</div>
              <div className="text-sm text-slate2 mt-2 leading-relaxed">{s.d}</div>
            </li>
          ))}
        </ol>
        <div className="mt-12 flex gap-3 flex-wrap">
          <Link to="/take-test" className="btn-primary" data-testid="hiw-take-test">Take the Test</Link>
          <Link to="/pricing" className="btn-ghost">View Pricing</Link>
        </div>
      </section>
    </Layout>
  );
}
